import type { ClassificationRule } from "@/services/api/classification-rules";
import type { SortDirection, SortField } from "./ClassificationRuleUtils";
import { ClassificationRulesTableHeader } from "./ClassificationRulesTableHeader";
import { ClassificationRulesTableRow } from "./ClassificationRulesTableRow";

interface ClassificationRulesTableProps {
  rules: ClassificationRule[];
  sortField: SortField;
  sortDirection: SortDirection;
  onSort: (field: SortField) => void;
  onEdit: (rule: ClassificationRule) => void;
  onDelete: (rule: ClassificationRule) => void;
}

export function ClassificationRulesTable({
  rules,
  sortField,
  sortDirection,
  onSort,
  onEdit,
  onDelete,
}: ClassificationRulesTableProps) {
  if (rules.length === 0) {
    return (
      <div className="py-12 text-center text-sm text-ink-500">
        No classification rules found.
      </div>
    );
  }

  return (
    <div className="max-h-[70vh] overflow-auto pb-8">
      <table className="w-full">
        <ClassificationRulesTableHeader
          sortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        <tbody className="divide-y divide-grid-200">
          {rules.map((rule) => (
            <ClassificationRulesTableRow
              key={String(rule.id)}
              rule={rule}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

